var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24.618 34.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M11.746,7.123H5.914V5.4A1.861,1.861,0,0,0,4.053,3.541h-5.49A1.861,1.861,0,0,0-3.3,5.4v1.72H-9.15a1.861,1.861,0,0,0-1.861,1.861V35.756A1.861,1.861,0,0,0-9.15,37.617h20.9a1.861,1.861,0,0,0,1.861-1.861V8.984A1.861,1.861,0,0,0,11.746,7.123ZM4.038,5.417l.006,1.705L4.047,9l.006,1.878-5.475.015L-1.427,9l-.006-1.876,0-1.705ZM-9.135,35.756-9.15,9H-3.3v1.893a1.861,1.861,0,0,0,1.861,1.861h5.49a1.861,1.861,0,0,0,1.861-1.861V9h5.816l.015,26.742Z",
    transform: "translate(11.011 -3.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M-3.909,19.569a1.024,1.024,0,0,1-.107-.008.936.936,0,0,1-.677-.418l-2.139-3.261a.936.936,0,0,1,.268-1.3.938.938,0,0,1,1.3.268l1.522,2.323L.964,12.691a.939.939,0,0,1,1.295,1.36l-5.52,5.257A.945.945,0,0,1-3.909,19.569Z",
    transform: "translate(14.537 4.251)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.d55876f5.svg";
export { ForwardRef as ReactComponent };